var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product.powerReviewsID)?_c('div',[_c('div',{staticClass:"pr-reviewsnippet",attrs:{"id":("pr-reviewsnippet-" + (_vm.product.powerReviewsID))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }